import { z } from 'zod';

/** C4 — requests autenticados de dados pessoais e senha da Clínica. */
export const UpdateCurrentUserRequestSchema = z.object({
  firstName: z.string().trim().min(1, 'Informe o nome.'),
  lastName: z.string().trim().min(1, 'Informe o sobrenome.'),
});

export const ChangeCurrentPasswordRequestSchema = z.object({
  code: z.string().regex(/^\d{6}$/u, 'O código tem 6 dígitos.'),
  newPassword: z.string()
    .min(8, 'A senha precisa de pelo menos 8 caracteres.')
    .refine((value) => /[A-Za-z]/u.test(value) && /\d/u.test(value), 'A senha precisa incluir letra e número.'),
});

export type UpdateCurrentUserInput = z.infer<typeof UpdateCurrentUserRequestSchema>;
export type ChangeCurrentPasswordInput = z.infer<typeof ChangeCurrentPasswordRequestSchema>;
